import styled from 'styled-components';
import { DropdownMenu as ReactstrapDropdownMenu } from 'reactstrap';

const DropdownMenu = styled(ReactstrapDropdownMenu)`
  background-color: ${({ theme }) => theme.designSystem.bgColors.card};
`;

export default DropdownMenu;
